module.exports = __webpack_public_path__ + "static/media/parkingbookingtile.e41c2581.png";